<div class="card mb-3 shadow-sm">
  <div class="card-header d-flex justify-content-between align-items-center flex-wrap">
    <h3 class="mb-2 mb-md-0">
      <i class="fa fa-map-marker-alt me-2"></i>
      Rutas registradas por bodega
    </h3>

    <div class="d-flex flex-wrap align-items-center gap-2">
      <div class="input-group input-group-sm me-2">
        <label for="datePicker" class="input-group-text fw-semibold">Fecha</label>
        <input id="datePicker" type="date" [(ngModel)]="selectedDate" (change)="loadRoutesFromBackend()" class="form-control" />
      </div>

      <div class="input-group input-group-sm">
        <label for="warehouseSelect" class="input-group-text fw-semibold">Bodega</label>
        <select id="warehouseSelect" [(ngModel)]="selectedWarehouse" (change)="loadRoutesFromBackend()" class="form-select">
          <option *ngFor="let w of warehouses" [ngValue]="w.id">{{ w.name }}</option>
        </select>
      </div>

      <div class="form-check form-switch ms-3">
        <input
          class="form-check-input"
          type="checkbox"
          id="toggleLabels"
          [(ngModel)]="showWarehouseLabels"
          (change)="loadRoutesFromBackend()"
        />
        <label class="form-check-label fw-semibold" for="toggleLabels">
          Mostrar nombres
        </label>
      </div>
    </div>
  </div>

  <div class="card-body p-0">
    <div class="map-container">
      <div id="map" class="map"></div>
    </div>
  </div>
</div>
<div *ngIf="selectedInvoice" class="details-popup">
  <h4>Factura: {{ selectedInvoice.clientInvoice.number }}</h4>
  <p>Cliente: {{ selectedInvoice.clientInvoice.name }}</p>
  <p>Fecha: {{ selectedInvoice.clientInvoice.date | date:'short' }}</p>
  <ul>
    <li *ngFor="let item of selectedInvoice.details">
      {{ item.descriptionProduct }} — {{ item.quantity }} × Q{{ item.price }}
    </li>
  </ul>
</div>
<app-modal-geographic-details
  [showModal]="showInvoiceModal"
  [invoiceData]="selectedInvoice"
  (closed)="showInvoiceModal = false">
</app-modal-geographic-details>


